import { RectangleEllipsisIcon } from "lucide-react";

import { prop, define } from "@/components/builder/utils";

import { DroppablePlaceholder } from "../utils/Placeholder";

import BasePreview from "./base";

function ButtonPreview({ children, properties: { content, tagName: Tag = 'button', allowChildren, ...properties }, ...props }) {
  return <BasePreview properties={properties} {...props}>
    <Tag className='m-0.5' onClick={e => e.preventDefault()}>
      {!allowChildren ? content : children || <DroppablePlaceholder>
        Drop here
      </DroppablePlaceholder>}
    </Tag>
  </BasePreview>
}

function ButtonHTML({ children, attributes, tagName: Tag, allowChildren, content }) {
  return <Tag {...attributes}>
    {allowChildren ? children : content}
  </Tag>
}

export default define('button', ButtonPreview, ButtonHTML)
  .palete(<RectangleEllipsisIcon size={16} />, 'Button', 'Content')
  .canvas()
  .property(prop.predefined.customClass())
  .property(prop.predefined.children())
  .property(prop.group('Tag', 'tagName').unique()
    .category('default')
    .ignoreDevice(true)
    .own()
    .blockClear()
    .options(prop.options()
      .add('button', 'button')
      .add('a', 'a'),
    ))
  .property(prop.predefined.content().own().ignoreDevice(true))
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .property(prop.predefined.nativeStyle())
  .property(prop.predefined.attributes())
  .property()
  .defaultProps({
    tagName: 'button',
    content: "Button",
    background: { color: 'blue-500' },
    textColor: 'gray-100',
    space: {
      padding: 'py-2 px-3',
    },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    cursor: 'cursor-pointer',
  })
  .build()
